import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141ecdff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-hero" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero-overlay" }, null, -1))
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "hero-inner" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"hero-badge\" data-aos=\"fade-down\" data-aos-duration=\"800\" data-v-141ecdff><i class=\"ri-leaf-line\" data-v-141ecdff></i> 100% Zabiha Halal </span><h1 data-aos=\"fade-up\" data-aos-duration=\"1000\" data-aos-delay=\"200\" data-v-141ecdff> Authentic Mexican.<br data-v-141ecdff><span class=\"text-accent\" data-v-141ecdff>Purely Halal.</span></h1><p class=\"hero-subtitle\" data-aos=\"fade-up\" data-aos-duration=\"1000\" data-aos-delay=\"400\" data-v-141ecdff> Fresh bowls, tacos &amp; quesadillas crafted with Zabiha halal meats and antibiotic-free produce — served fast-casual style. </p>", 3)
const _hoisted_9 = {
  class: "hero-actions",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "600"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-funds-line" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-restaurant-line" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-badges\" data-aos=\"fade-up\" data-aos-duration=\"1000\" data-aos-delay=\"800\" data-v-141ecdff><div class=\"badge-item\" data-v-141ecdff><i class=\"ri-star-fill\" data-v-141ecdff></i><span data-v-141ecdff>4.9 on Google</span></div><div class=\"badge-divider\" data-v-141ecdff></div><div class=\"badge-item\" data-v-141ecdff><i class=\"ri-map-pin-2-fill\" data-v-141ecdff></i><span data-v-141ecdff>1244 Stors Rd, Storrs Mansfield</span></div><div class=\"badge-divider\" data-v-141ecdff></div><div class=\"badge-item\" data-v-141ecdff><i class=\"ri-time-line\" data-v-141ecdff></i><span data-v-141ecdff>Open Daily</span></div></div>", 1)
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hero-scroll-indicator",
  "data-aos": "fade-up",
  "data-aos-delay": "1200"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Scroll"),
  /*#__PURE__*/_createElementVNode("div", { class: "scroll-line" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              href: "#investment",
              class: "btn-primary-hero",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToInvestment && _ctx.scrollToInvestment(...args)), ["prevent"]))
            }, [
              _hoisted_10,
              _createTextVNode(" Franchise Investment ")
            ]),
            _createElementVNode("a", {
              href: "#menu",
              class: "btn-secondary-hero",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToMenu && _ctx.scrollToMenu(...args)), ["prevent"]))
            }, [
              _hoisted_11,
              _createTextVNode(" View Menu ")
            ])
          ]),
          _hoisted_12
        ])
      ])
    ]),
    _hoisted_13
  ]))
}